"use strict";
var gpml_utilities_1 = require("./gpml-utilities");
var STATE_DEFAULTS = {
    attributes: {
        Padding: {
            name: 'Padding',
            value: '0.1em'
        },
        ShapeType: {
            name: 'ShapeType',
            value: 'Rectangle'
        },
        Color: {
            name: 'Color',
            value: '000000'
        },
        FillColor: {
            name: 'FillColor',
            value: 'ffffff'
        },
        FontSize: {
            name: 'FontSize',
            value: 10
        },
        LineThickness: {
            name: 'LineThickness',
            value: 1
        },
        Align: {
            name: 'Align',
            value: 'Center'
        },
        Valign: {
            name: 'Valign',
            value: 'Middle'
        }
    }
};
function applyDefaults(gpmlElement, defaults) {
    return gpml_utilities_1.applyDefaults(gpmlElement, [STATE_DEFAULTS, defaults]);
}
exports.applyDefaults = applyDefaults;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RhdGUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvc3RhdGUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLG1EQUFzRTtBQUV0RSxJQUFNLGNBQWMsR0FBRztJQUN0QixVQUFVLEVBQUU7UUFDWCxPQUFPLEVBQUU7WUFDUixJQUFJLEVBQUUsU0FBUztZQUNmLEtBQUssRUFBRSxPQUFPO1NBQ2Q7UUFDRCxTQUFTLEVBQUU7WUFDVixJQUFJLEVBQUUsV0FBVztZQUNqQixLQUFLLEVBQUUsV0FBVztTQUNsQjtRQUNELEtBQUssRUFBRTtZQUNOLElBQUksRUFBRSxPQUFPO1lBQ2IsS0FBSyxFQUFFLFFBQVE7U0FDZjtRQUNELFNBQVMsRUFBRTtZQUNWLElBQUksRUFBRSxXQUFXO1lBQ2pCLEtBQUssRUFBRSxRQUFRO1NBQ2Y7UUFDRCxRQUFRLEVBQUU7WUFDVCxJQUFJLEVBQUMsVUFBVTtZQUNmLEtBQUssRUFBQyxFQUFFO1NBQ1I7UUFDRCxhQUFhLEVBQUU7WUFDZCxJQUFJLEVBQUUsZUFBZTtZQUNyQixLQUFLLEVBQUUsQ0FBQztTQUNSO1FBQ0QsS0FBSyxFQUFFO1lBQ04sSUFBSSxFQUFFLE9BQU87WUFDYixLQUFLLEVBQUUsUUFBUTtTQUNmO1FBQ0QsTUFBTSxFQUFFO1lBQ1AsSUFBSSxFQUFFLFFBQVE7WUFDZCxLQUFLLEVBQUUsUUFBUTtTQUNmO0tBQ0Q7Q0FDRCxDQUFDO0FBRUYsdUJBQThCLFdBQVcsRUFBRSxRQUFRO0lBQ2xELE1BQU0sQ0FBQyw4QkFBaUIsQ0FBQyxXQUFXLEVBQUUsQ0FBQyxjQUFjLEVBQUUsUUFBUSxDQUFDLENBQUMsQ0FBQztBQUNuRSxDQUFDO0FBRkQsc0NBRUM7QUFBQSxDQUFDIn0=


//////////////////
// WEBPACK FOOTER
// ./~/gpml2pvjson/lib/state.js
// module id = 713
// module chunks = 0